import { Formik } from "formik";
import { Row, Col, FloatingLabel, Form } from "react-bootstrap";
import { SubscriptionModel } from "../../data/entities";
import { OrganizationService, SubscriptionService } from "../../services";
import { useUrlParams,
  useAsync,
  useCRUDHandlers,
  useSetPageTitle,
  usePermission,
  useGridActions,
} from "../../hooks";
import { usePageActions } from "../PageLayout";
import { PermissionDefinitions } from "../../security";
import { Button, Card, IconAndText, IconDefinitions } from "../../components";
import { routes } from "../../app/routes";
import { AddPaymentInformationModal } from "./components";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

interface SubscriptionBillingInfoPageProps {
}
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "");

export function SubscriptionBillingInfoPage(props: Readonly<SubscriptionBillingInfoPageProps>) {

  const subscriptionId = parseInt(useUrlParams("id"));
  const subscriptionService = new SubscriptionService();
  const {value: subscription} = useAsync(() => subscriptionService.get(subscriptionId), [subscriptionId]);
  const { showAddState } = useGridActions<SubscriptionModel>(routes.host.subscription.billingInfo);

  const organizationId = subscription?.organizationId!;
  const organizationService = new OrganizationService();
  const {value: organization } = useAsync(() => organizationService.get(organizationId), [organizationId] );
  const canAddPaymentInformation = usePermission(PermissionDefinitions.host.create());

  const { editItem } = useCRUDHandlers<SubscriptionModel>(subscriptionService, "Subscription");

  useSetPageTitle("Billing Info", [subscriptionId]);
   usePageActions(
    canAddPaymentInformation && (
      <Button
        onClick={() => {
          showAddState.setter(true);
        }}
      >
        <IconAndText iconName={IconDefinitions.add} text="Add Payment" />
      </Button>
    )
    , [canAddPaymentInformation]
  );


  if(subscription === null || subscription === undefined) return null;
  if(organization === null || organization=== undefined) return null;

  const handlePaymentSuccess = () => {
    showAddState.setter(false);
  };

  return (
    <Card title="Billing">
      <Formik
        initialValues={{
          name: subscription.name,
          frequency: subscription.frequency,
          organizationName: organization?.name,
          startDate: subscription.startDate,
          price: subscription.price,
          paymentIntentId: "",
        }}
        onSubmit={(values) => {
          editItem({
            ...subscription,
            ...values,
          })
        }}
      >
        {({ values}) => (
          <Form>
            <Row>
              <Col>
                <Form.Group controlId="name">
                  <FloatingLabel label="Name" className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={values.name}
                      disabled={true}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group controlId="organizationName">
                  <FloatingLabel label="Organization Name" className="mb-3">
                    <Form.Control
                      type="text"
                      placeholder="Organization"
                      name="organizationName"
                      value={organization?.name}
                      disabled={true}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
            </Row>

            <hr className="mt-0"/>

            <Row>
              <Col>
                <Form.Group controlId="paymentIntentId">
                  <FloatingLabel label="Payment Token" className="mb-3">
                    <Form.Control
                      name="paymentIntentId"
                      placeholder="Payment"
                      value={subscription.paymentIntentId || "None"}
                      disabled={true}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>

      <Elements stripe={stripePromise}>
        <AddPaymentInformationModal
            showAddState={showAddState}
            showState={showAddState}
            onSubmit={handlePaymentSuccess}
        />
      </Elements>

    </Card>
  );
}

export default SubscriptionBillingInfoPage;

